import { expVal } from '@confluence/feature-experiments';

/**
 * Re-evaluates experiments in the browser when their initial evaluation cannot emit an exposure.
 */
export const fireSSRExperimentExposures = () => {
	expVal('move_statsig_bootstrap_after_fmp', 'isEnabled', false);
	expVal('confluence_media_token_preload_agg_query', 'isEnabled', false);
	expVal('confluence_skip_ors_for_jira_smartlinks', 'isEnabled', false);
	// The server reads this in addLoadableId for streamed pages, so only those pages are exposed.
	if (window.__SSR_REACT_STREAMING__) {
		expVal('confluence_ssr_streamed_loadable_preload', 'isEnabled', false);
	}
};
